import { DashboardOutlined } from '@material-ui/icons';
import { GetRoutesConfig, RoutesMaps } from '../common/routes-map-model';
import { getMenuLabel } from '../../global/auth/use-menu-labels/use-menu-labels';

const route = 'warmth';

export const getFixedRoutesMap = ({ userIdentityService, org }: GetRoutesConfig): RoutesMaps => {
  const { isVolunteer, isActivityLeader, isProgramManager, isVmAdmin } = userIdentityService;
  // Default to true if org data is not available yet
  const packageConfig = org?.packageConfig;
  const menuLabels = org?.menuLabels;

  return {
    route,
    heading: 'Dashboard',
    Icon: DashboardOutlined,
    isAuthorized: isVolunteer,
    items: [
      {
        ...getMenuLabel('dashboardHome', menuLabels),
        route: `my-elements`,
        isAuthorized: isVolunteer,
      },
      {
        ...getMenuLabel('dashboardResources', menuLabels),
        route: 'resources',
        isAuthorized: true,
      },
      {
        ...getMenuLabel('dashboardImpact', menuLabels),
        route: 'impact-dashboard',
        isAuthorized: isActivityLeader || isProgramManager || isVmAdmin,
        hidden: packageConfig ? !packageConfig.rostering : false,
      },
    ],
  };
};
